import { render, staticRenderFns } from "./policies_show.vue?vue&type=template&id=30c46560&scoped=true&"
import script from "./policies_show.vue?vue&type=script&lang=js&"
export * from "./policies_show.vue?vue&type=script&lang=js&"
import style0 from "./policies_show.vue?vue&type=style&index=0&id=30c46560&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c46560",
  null
  
)

export default component.exports